// Intake form schema constants. The 12 consent clauses below are VERBATIM from
// Medical_Marijuana_Patient_Form_Template.pdf and must not be edited without
// legal review. Their keys mirror REQUIRED_CONSENT_KEYS on the backend in
// submit_patient_intake/index.js.

export const INTAKE_PAGES = [
  { id: 'patient_info', label: 'Your Info' },
  { id: 'medical_history', label: 'Medical History' },
  { id: 'lifestyle', label: 'Lifestyle' },
  { id: 'mental_health', label: 'Mental Health' },
  { id: 'pcp', label: 'Doctor & Renewal' },
  { id: 'consent', label: 'Consent & Sign' },
];

export const MEDICAL_CONDITIONS = [
  "ALS (Lou Gehrig's Disease)",
  "Alzheimer's Disease",
  'Anxiety',
  'Arthritis',
  'Autism Spectrum Disorder',
  'Cancer',
  'Chronic Pain',
  "Crohn's Disease",
  'Epilepsy',
  'Fibromyalgia',
  'Glaucoma',
  'Hepatitis C',
  'HIV/AIDS',
  'Inflammatory Bowel Disease',
  'Insomnia',
  'Loss of Appetite',
  'Migraine Headaches',
  'Multiple Sclerosis (MS)',
  'Muscle Spasm',
  'Nausea',
  'Neuropathy',
  'Opioid Use Disorder',
  "Parkinson's Disease",
  'PTSD',
  'Seizures',
  'Severe Pain',
  'Sickle Cell Anemia',
  'Spinal Cord Injury',
  'Terminal Illness',
  'Tourette Syndrome',
  'Traumatic Brain Injury (TBI)',
  'Ulcerative Colitis',
  'Weight Loss',
];

export const MENTAL_HEALTH_CONDITIONS = [
  'Depression',
  'Bipolar Disorder',
  'Schizophrenia',
  'Suicidal Thoughts',
  'ADHD',
  'None of the above',
];

// Keys MUST match REQUIRED_CONSENT_KEYS in submit_patient_intake. Order here
// matches the order of clauses in the source PDF (sections 65-94).
export const CONSENT_CLAUSES = [
  {
    key: 'federal_law',
    text: 'I understand that the cultivation, possession, and use of marijuana — even for medical purposes — are currently illegal under federal law.',
  },
  {
    key: 'no_school_zones',
    text: 'Under federal and state law, it is not permitted to use or possess marijuana within 1,000 feet of a daycare or school. I agree not to do so.',
  },
  {
    key: 'no_alcohol_combo',
    text: 'I agree not to use marijuana while under the influence of alcohol.',
  },
  {
    key: 'no_driving',
    text: 'I understand that it is against the law to drive a vehicle while using marijuana, and that doing so may result in a DUI charge.',
  },
  {
    key: 'disclose_mental_health',
    text: 'I agree to tell the attending physician if I have ever had symptoms of depression, been psychotic, attempted suicide, or had any other mental health conditions. I also agree to tell the physician if I have ever been prescribed medication for any such condition. I understand that the attending physician does not suggest or condone that I cease treatment or medication that stabilizes my mental or physical condition.',
  },
  {
    key: 'stop_if_suicidal',
    text: 'I agree to immediately stop using marijuana and inform the physician if I become suicidal, homicidal, paranoid, or experience an increase in any such symptoms.',
  },
  {
    key: 'disclose_meds',
    text: 'There are few well-studied interactions between marijuana and other medications or herbs. I agree to tell my attending physician if I am using any herbs, supplements, or other medications.',
  },
  {
    key: 'tolerance_breaks',
    text: 'Some users may develop a tolerance to marijuana, meaning higher doses are required to achieve the same clinical effect. A drug-free interval of at least three weeks every three to four months is recommended. I agree to notify my physician if I believe I am developing a tolerance.',
  },
  {
    key: 'respiratory_problems',
    text: 'Should respiratory problems or other ill effects occur in association with the use of medical marijuana, I agree to discontinue use and report such problems to the attending physician. Smoking marijuana can cause respiratory harm such as bronchitis, and marijuana smoke contains known carcinogens. Vaporizers may substantially reduce many of the harmful compounds present in marijuana smoke.',
  },
  {
    key: 'dosage_awareness',
    text: 'Marijuana varies in potency, and effects vary by delivery method. Estimating proper dosage is important. Symptoms of overdose may include nausea, vomiting, cough, disturbances to heart rhythm, and numbness in the limbs.',
  },
  {
    key: 'no_dosage_recommendations',
    text: 'Under federal law, the attending physician is unable to discuss specific dosage recommendations.',
  },
  {
    key: 'fda_unregulated',
    text: 'Cannabis is not regulated by the U.S. FDA and may therefore contain unknown quantities of active ingredients, impurities, or contaminants.',
  },
];

export const REQUIRED_CONSENT_KEYS = CONSENT_CLAUSES.map((c) => c.key);

// Used by the validator. Patient must be 18+ at the time of intake. Some states
// allow minors with parental consent; phase 2 work.
export const MIN_PATIENT_AGE = 18;

// Storage key for the local mirror of in-progress responses.
export const INTAKE_LOCAL_STORAGE_PREFIX = 'intake:';
